module.exports = __webpack_public_path__ + "img/mail-white-light.51c69637.svg";